import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
 CheckCircleIcon,
 StarIcon,
 ClockIcon,
 UserGroupIcon
} from '@heroicons/react/24/outline';
import { unlockAllClicks } from '../utils/mockInterviewClickTracker';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Unlock mock interview clicks after payment success
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.userId) {
        unlockAllClicks(user.userId);
        console.log('✅ Mock interview clicks unlocked for user:', user.userId);
      }
    } catch (err) {
      console.error('Error unlocking clicks:', err);
    }

    // Auto redirect to dashboard after 10 seconds (increased to let them see the receipt info)
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const subscriptionData = JSON.parse(localStorage.getItem('subscription_data') || '{}');
  const endDate = new Date(subscriptionData.subscriptionEnd);
  const formattedEndDate = endDate.toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center p-6 relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/20 rounded-full blur-[120px] -mr-64 -mt-64"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-secondary/10 rounded-full blur-[120px] -ml-64 -mb-64"></div>
      
      <div className="max-w-2xl w-full bg-bgSection/80 backdrop-blur-xl rounded-[40px] p-10 text-center border border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.5)] relative z-10">
        {/* Branding */}
        <div className="mb-8">
          <h2 className="text-primary font-black text-xs tracking-[0.3em] uppercase mb-2">SkillGenie</h2>
          <p className="text-white/40 text-[10px] font-bold tracking-[0.2em] uppercase">Powered by EvolveX Innovations</p>
        </div>

        {/* Success Icon */}
        <div className="mb-8 relative inline-block">
          <div className="absolute inset-0 bg-green-500/20 blur-2xl rounded-full"></div>
          <CheckCircleIcon className="h-28 w-28 text-green-400 mx-auto relative z-10 drop-shadow-[0_0_15px_rgba(74,222,128,0.5)]" />
        </div>
        
        <h1 className="text-4xl md:text-5xl font-black text-white mb-4 tracking-tighter uppercase italic">
          Payment <span className="text-green-400">Successful!</span>
        </h1>
        <p className="text-muted text-xl font-medium mb-10">
          Your Premium journey begins now.
        </p>

        {/* Subscription Card */}
        <div className="bg-black/40 rounded-[32px] p-8 mb-10 border border-white/5 shadow-inner">
          <div className="flex items-center justify-center gap-3 mb-6">
            <StarIcon className="h-7 w-7 text-primary drop-shadow-[0_0_8px_rgba(43,176,230,0.5)]" />
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">Premium Plan Active</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
            <div className="bg-white/5 p-4 rounded-2xl flex items-center gap-4 border border-white/5">
              <div className="w-10 h-10 bg-primary/20 rounded-xl flex items-center justify-center">
                <ClockIcon className="h-6 w-6 text-primary" />
              </div>
              <div className="text-left">
                <span className="text-muted text-[10px] font-bold uppercase block tracking-wider">Valid Until</span>
                <span className="text-white font-black text-base">{formattedEndDate}</span>
              </div>
            </div>
            
            <div className="bg-white/5 p-4 rounded-2xl flex items-center gap-4 border border-white/5">
              <div className="w-10 h-10 bg-secondary/20 rounded-xl flex items-center justify-center">
                <UserGroupIcon className="h-6 w-6 text-secondary" />
              </div>
              <div className="text-left">
                <span className="text-muted text-[10px] font-bold uppercase block tracking-wider">Current Plan</span>
                <span className="text-white font-black text-base">Premium Elite</span>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <button
            onClick={() => navigate('/mockinterviewpayments_history')}
            className="w-full bg-primary text-white py-5 rounded-[20px] font-black uppercase tracking-widest text-xs shadow-xl shadow-primary/20 hover:scale-[1.02] active:scale-95 transition-all"
          >
            Download Receipt
          </button>
          
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-white/5 text-white border border-white/10 py-5 rounded-[20px] font-black uppercase tracking-widest text-xs hover:bg-white/10 transition-all"
          >
            Go to Dashboard
          </button>
        </div>
        
        <p className="mt-8 text-muted/50 text-[10px] font-bold uppercase tracking-[0.2em]">
          Redirecting to dashboard in 10 seconds...
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;










